import React, { useState } from 'react';

/*Hooks*/
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';

/*Components*/
import { Box, Menu, Avatar, Typography, Divider, Button, IconButton } from '@mui/material';
import { Stack } from '@mui/system';
import Scrollbar from '@components/custom-scroll/Scrollbar';

/*Actions*/
import { onCreateTestEvent } from '@store/common/actions';

/*Selectors*/
import { getUserData } from '@store/user/selector';
import { getStatusTesting } from '@store/common/selector';

/*Helpers*/
import { logout } from '@utility/function/logout';

/*Images*/
import icon1 from '@assets/images/svgs/icon-account.svg';
import icon3 from 'src/assets/images/svgs/icon-tasks.svg';

const eventId = localStorage.getItem('eventId');

const roles = localStorage.getItem('roles');
const isImpersonation = localStorage.getItem('isImpersonation');

const Profile = () => {
  const dispatch = useDispatch();
  const [anchorEl2, setAnchorEl2] = useState(null);
  const userData = useSelector(getUserData);
  const statusTesting = useSelector(getStatusTesting);

  const { t } = useTranslation();
  const history = useHistory();

  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const handleCreateTesting = () => {
    if (!!userData?.eventId || !!eventId) {
      dispatch(
        onCreateTestEvent({ eventId: userData?.eventId || eventId, userCreated: userData?.id }),
      );
    }
  };

  return (
    <Box>
      <IconButton
        size="large"
        aria-label="show 11 new notifications"
        color="inherit"
        aria-controls="msgs-menu"
        aria-haspopup="true"
        sx={{
          ...(typeof anchorEl2 === 'object' && {
            color: 'primary.main',
          }),
        }}
        onClick={handleClick2}
      >
        <Avatar
          src={isImpersonation || roles === 'BTC' ? userData?.mstEvent?.linkIcon : userData.avatar}
          alt={userData?.name}
          sx={{
            width: 35,
            height: 35,
          }}
        />
      </IconButton>
      <Menu
        id="msgs-menu"
        anchorEl={anchorEl2}
        keepMounted
        open={Boolean(anchorEl2)}
        onClose={handleClose2}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        sx={{
          '& .MuiMenu-paper': {
            width: '360px',
          },
        }}
      >
        <Scrollbar sx={{ height: '100%', maxHeight: '85vh' }}>
          <Box p={3}>
            <Typography variant="h5">{t('CORE:profile')}</Typography>
            <Stack direction="row" py={3} spacing={2} alignItems="center">
              <Avatar
                src={
                  isImpersonation || roles === 'BTC'
                    ? userData?.mstEvent?.linkIcon
                    : userData.avatar
                }
                alt={userData?.name}
                sx={{ width: 95, height: 95 }}
              />
              <Box>
                <Typography variant="subtitle2" color="textPrimary" fontWeight={600}>
                  {userData?.name}
                </Typography>
                <Typography variant="subtitle2" color="textSecondary">
                  {userData?.roles}
                </Typography>
              </Box>
            </Stack>
            <Divider />
            {(!statusTesting || statusTesting === 'notested' || statusTesting === 'tested') &&
              roles === 'BTC' && (
                <Box key={'checking'}>
                  <Box sx={{ py: 2, px: 0 }} className="hover-text-primary">
                    <Link to={'#'} onClick={() => history.push('/account')}>
                      <Stack direction="row" spacing={2}>
                        <Box
                          width="45px"
                          height="45px"
                          bgcolor="primary.light"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Avatar
                            src={icon1}
                            alt={'testing'}
                            sx={{
                              width: 24,
                              height: 24,
                              borderRadius: 0,
                            }}
                          />
                        </Box>
                        <Box>
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            color="textPrimary"
                            className="text-hover"
                            noWrap
                            sx={{
                              width: '240px',
                            }}
                          >
                            {t('CORE:profile')}
                          </Typography>
                          <Typography
                            color="textSecondary"
                            variant="subtitle2"
                            sx={{
                              width: '240px',
                            }}
                            noWrap
                          >
                            {t('CORE:profile_desc')}
                          </Typography>
                        </Box>
                      </Stack>
                    </Link>
                  </Box>
                  <Box sx={{ py: 2, px: 0 }} className="hover-text-primary">
                    <Link to={'#'} onClick={handleCreateTesting}>
                      <Stack direction="row" spacing={2}>
                        <Box
                          width="45px"
                          height="45px"
                          bgcolor="primary.light"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Avatar
                            src={icon3}
                            alt={'testing'}
                            sx={{
                              width: 24,
                              height: 24,
                              borderRadius: 0,
                            }}
                          />
                        </Box>
                        <Box>
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            color="textPrimary"
                            className="text-hover"
                            noWrap
                            sx={{
                              width: '240px',
                            }}
                          >
                            {t('CORE:testing_mode')}
                          </Typography>
                          <Typography
                            color="textSecondary"
                            variant="subtitle2"
                            sx={{
                              width: '240px',
                            }}
                            noWrap
                          >
                            {t('CORE:testing_mode_desc')}
                          </Typography>
                        </Box>
                      </Stack>
                    </Link>
                  </Box>
                </Box>
              )}

            <Box mt={2}>
              <Button onClick={logout} variant="outlined" color="primary" fullWidth>
                {t('CORE:logout')}
              </Button>
            </Box>
          </Box>
        </Scrollbar>
      </Menu>
    </Box>
  );
};

export default Profile;
